import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { TCommentId } from '../../../../../../../../store/model/card/types/IComment';
import { TDriveDocId } from '../../../../../../../../types/rest/IRestDriveDoc';
import { commentUpdate } from '../../../store/reducers/actions/commentUpdate';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { IGetState } from '../../../../../../../../types/types';

export const onAttachmentReply = (
    commentId: TCommentId,
    driveDocId: TDriveDocId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(commentUpdate({
            replyCommentId: commentId,
            replyAttachmentId: driveDocId,
            replyText: null,
            editCommentId: null,
        }));
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_REPLY_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));
    };

    return action;
};
